import { render, staticRenderFns } from "./AdminCasesResult.vue?vue&type=template&id=83023aa4"
import script from "./AdminCasesResult.vue?vue&type=script&lang=js"
export * from "./AdminCasesResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports